import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "context";
import { Form } from "components";
import { Routes } from "utils";
import { Typography } from "@mui/material";

export const ForgotPassword = () => {
  const { t, theme } = useApp();

  return (
    <div className="qh-page">
      <div className="qh-wrapper">
        <div className="qh-illustration"></div>
        <div className="qh-header" style={{ color: theme.palette.font.color }}>
          <div className="title">{t.title.auth.forgot_password}</div>
        </div>
        <div className="qh-content">
          <Form.ForgotPassword />
        </div>
        <div className="qh-footer">
          <div className="footnote">
            <Typography sx={{ marginRight: theme.margin.xs }}>
              {t.message.auth.cancel_change}
            </Typography>
            <Link
              to={Routes.auth.signin}
              style={{ color: theme.palette.font.color }}
            >
              {t.action.sign_in}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
